import axios from 'axios';

// In production the dashboard and API are served behind the same Nginx host.
// If a local-development bundle is served remotely, do not make the browser
// call the user's own computer at localhost:3000; use the current origin.
const configuredApiBase = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
const browserHostname = typeof window !== 'undefined' ? window.location.hostname : '';
const remoteBrowserUsingLocalApi = Boolean(
  browserHostname
  && !['localhost', '127.0.0.1', '::1'].includes(browserHostname)
  && /^https?:\/\/localhost(?::\d+)?$/i.test(configuredApiBase),
);
export const API_BASE_URL = remoteBrowserUsingLocalApi ? '' : configuredApiBase;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 5000,
  withCredentials: true,
});

function readCookie(name) {
  const prefix = `${name}=`;
  const match = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
  return match ? decodeURIComponent(match.slice(prefix.length)) : '';
}

api.interceptors.request.use((config) => {
  const csrfToken = readCookie('kite_dashboard_csrf');
  if (csrfToken) config.headers['X-CSRF-Token'] = csrfToken;
  return config;
});

export default api;
